<template>
  <section>
    <div class="container">
      <div class="row justify-content-center justify-content-md-between">
        <div class="col-auto px-0">
          <mdb-btn flat dark-waves icon="arrow-left" type="button" title="Regresar" @click="$router.go(-1)">
            Regresar
          </mdb-btn>
        </div>
      </div>
      <div class="encabezado-detalles">
        <header class="h4-responsive text-center pt-3">Reporte</header>
        <div class="row mx-0 mt-2">
          <div class="col-12 col-md-4">
            <span class="small-block font-titulo">Nombre del reporte</span>
            <p>
              Comisiones e Incentivos
            </p>
          </div>
          <div class="col-12">
            <span class="small-block font-titulo">Descripción</span>
            <p class="mb-1">
              Cuadro de comisiones e incentivos por mes
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-4">
          <mdb-input v-model="fechaMes" type="month" label="Mes" class="my-2" outline />
        </div>
        <!-- Fecha Desde -->
        <div class="col-12 col-md-4">
          <mdb-input class="my-2" v-model="fechaDel" type="date" label="Desde" outline
            @input="$emit('desdeAFiltrar', fechaDel);" />
        </div>
        <!-- Fecha Hasta -->
        <div class="col-12 col-md-4">
          <mdb-input class="my-2" v-model="fechaHasta" type="date" label="Hasta" outline
            @input="$emit('hastaAFiltrar', fechaHasta);" />
        </div>
        <!-- <div class="col-12 col-md-6 col-xl-3 px-0">
          <FiltrosTipo1 :ven="vendedores" :responsive="responsive" :restablecer-filtrado="restablecer"
            :mostrar-btn-restablecer="false" @vendedorAFiltrar="vendedoresFiltrados = $event; actualizar()" />
        </div> -->
      </div>
    </div>
    <div v-if="fechaHasta.length && fechaDel.length" class="col-12 col-md text-center">
      <mdb-btn flat dark-waves icon="broom" class="my-2 px-1" @click="restablecerFiltros()">
        Restablecer filtros
      </mdb-btn>
    </div>
    <div v-if="cargando" class="mensaje-no-items py-3">
      <LoaderKel />
      <p class="texto mt-2">
        Cargando
      </p>
    </div>
    <!-- Mensaje cuando el vendedor seleccionado no tiene pedido -->
    <div v-if="!data.length" class="mensaje-no-items pb-3">
      <font-awesome-icon icon="clipboard-list" size="5x" class="icono" />
      <p class="texto">No hay reportes según los parámetros seleccionados</p>
    </div>
    <div class="container" v-else>
      <div class="table-container">
        <div class="table-wrapper">
          <table>
            <thead>
              <th>
                <div class="ancho-3">
                  Vendedores
                </div>
              </th>
              <th>
                <div>
                  com. en $ <br>
                  en el primer corte
                </div>
              </th>
              <th>
                <div>
                  com. en $ <br>
                  en el segundo corte
                </div>
              </th>
              <th>
                <div>
                  Total pago <br>
                  de com. <br>
                  sin incentivo
                </div>
              </th>
              <th>
                <div>
                  com. de productos <br>
                  masivos
                </div>
              </th>
              <th>
                <div>
                  com. de productos <br>
                  industriales
                </div>
              </th>
              <th>
                <div>
                  com. de productos <br>
                  distribuidor
                </div>
              </th>
              <th>
                <div>
                  % del incentivo
                </div>
              </th>
              <th>
                <div>
                  Com. que no entra <br>
                  en el incentivo <br>
                  (indus. dist.)
                </div>
              </th>
              <th>
                <div>
                  Com. para el <br>
                  calculo de incentivo
                </div>
              </th>
              <th>
                <div>
                  Incentivo
                </div>
              </th>
              <th>
                <div>
                  Total a pagar
                </div>
              </th>
            </thead>
            <tbody>
              <tr v-for="(p, i) in data" :key="i">
                <td data-columna="Vendedores">
                  <div>
                    <p class="">
                      {{ p.vendedor }}
                    </p>
                  </div>
                </td>
                <td data-columna="Com. en $ en el primer corte">
                  <div class="">
                    <p>{{ p.comision_primer_corte }}</p>
                  </div>
                </td>
                <td data-columna="Com. en $ en el segundo corte">
                  <div class="">
                    <p>{{ p.comision_segundo_corte }}</p>
                  </div>
                </td>
                <td data-columna="Total pago com. sin incentivo">
                  <div class="">
                    <p>{{ p.total_comisiones_sin_incentivo }}</p>
                  </div>
                </td>
                <td data-columna="Com. de productos Masiv.">
                  <p>
                    {{ p.comisiones_masivos }}
                  </p>
                </td>
                <td data-columna="Com. de productos Indus.">
                  <div class="">
                    <p>{{ p.comisiones_industriales }}</p>
                  </div>
                </td>
                <td data-columna="Com. de productos Dis.">
                  <p>
                    {{ p.comisiones_distribuidor }}
                  </p>
                </td>
                <td data-columna="% De incentivo">
                  <p>
                    {{ p.porcentaje_incentivo }}
                  </p>
                </td>
                <td data-columna="Com. que no entra en el Incen. (Indus. y Dis.)">
                  <p>
                    {{ p.comision_no_entra_incentivo }}
                  </p>
                </td>
                <td data-columna="Com. para el calculo de Ince.">
                  <p>
                    {{ p.comisiones_calculo_incentivo }}
                  </p>
                </td>
                <td data-columna="Incentivo">
                  <p>
                    {{ p.incentivo }}
                  </p>
                </td>
                <td data-columna="Total a pagar">
                  <p>
                    {{ p.total_a_pagar }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

    </div>

    <AlertaMensaje :alerta-mensaje="alertaMensaje" @cerrar="alertaMensaje.contenido = ''" />
  </section>
</template>

<script>
import { mdbInput, mdbBtn } from 'mdbvue'
// import FiltrosTipo1 from '@/components/FiltrosTipo1.vue'
import AlertaMensaje from '@/components/AlertaMensaje.vue'
import LoaderKel from '@/components/LoaderKel.vue'
import { apiPost } from '@/funciones/api.js'
import { convertirNumeroAFixed } from '@/funciones/funciones.js'
export default {
  name: 'Actividades',
  components: {
    mdbInput,
    mdbBtn,
    // FiltrosTipo1,
    AlertaMensaje,
    LoaderKel
  },
  data () {
    return {
      cargando: false,
      responsive: { vendedor: 'col-12', btnRestablecer: 'col-12 col-md-auto' },
      vendedores: [],
      vendedoresFiltrados: [],
      vendedoresSeleccionados: [],
      fechaMes: (new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).substr(-2)).toString(),
      fechaDel: '',
      fechaHasta: '',
      alertaMensaje: { contenido: '' },
      restablecer: false,
      data: [
        {
          vendedor: 'LARA - JUAN CANELON',
          comision_primer_corte: 72.95,
          comision_segundo_corte: 122.61,
          total_comisiones_sin_incentivo: 195.56,
          comisiones_masivos: 195.56,
          comisiones_industriales: 0,
          comisiones_distribuidor: 0,
          porcentaje_incentivo: 0.15,
          comision_no_entra_incentivo: 0,
          comisiones_calculo_incentivo: 195.56,
          incentivo: 29.33,
          total_a_pagar: 224.89
        },
        {
          vendedor: 'MERIDA - DANIEL MENDEZ',
          comision_primer_corte: 221.64,
          comision_segundo_corte: 41.13,
          total_comisiones_sin_incentivo: 262.77,
          comisiones_masivos: 196.88,
          comisiones_industriales: 2.80,
          comisiones_distribuidor: 63.09,
          porcentaje_incentivo: 0.65,
          comision_no_entra_incentivo: 65.89,
          comisiones_calculo_incentivo: 196.88,
          incentivo: 127.97,
          total_a_pagar: 390.74
        },
        {
          vendedor: 'TACHIRA - JOSMER MORA',
          comision_primer_corte: 327.64,
          comision_segundo_corte: 177.45,
          total_comisiones_sin_incentivo: 505.09,
          comisiones_masivos: 505.09,
          comisiones_industriales: 0,
          comisiones_distribuidor: 0,
          porcentaje_incentivo: 0.75,
          comision_no_entra_incentivo: 0,
          comisiones_calculo_incentivo: 505.09,
          incentivo: 378.82,
          total_a_pagar: 883.91
        },
        {
          vendedor: 'ARAGUA - GENNIS ECHEVERRIA',
          comision_primer_corte: 400.12,
          comision_segundo_corte: 205.00,
          total_comisiones_sin_incentivo: 605.12,
          comisiones_masivos: 334.61,
          comisiones_industriales: 51.37,
          comisiones_distribuidor: 219.14,
          porcentaje_incentivo: 0.55,
          comision_no_entra_incentivo: 270.51,
          comisiones_calculo_incentivo: 334.61,
          incentivo: 184.04,
          total_a_pagar: 789.16
        },
        {
          vendedor: 'CARABOBO - RAFAEL USEA',
          comision_primer_corte: 153.50,
          comision_segundo_corte: 232.84,
          total_comisiones_sin_incentivo: 386.34,
          comisiones_masivos: 355.71,
          comisiones_industriales: 30.63,
          comisiones_distribuidor: 0,
          porcentaje_incentivo: 0.70,
          comision_no_entra_incentivo: 30.63,
          comisiones_calculo_incentivo: 355.71,
          incentivo: 249.00,
          total_a_pagar: 635.34
        },
        {
          vendedor: 'BARINAS - LUIZ PIMENTEL',
          comision_primer_corte: 187.93,
          comision_segundo_corte: 252.07,
          total_comisiones_sin_incentivo: 440.00,
          comisiones_masivos: 315.28,
          comisiones_industriales: 0,
          comisiones_distribuidor: 124.72,
          porcentaje_incentivo: 0.45,
          comision_no_entra_incentivo: 124.72,
          comisiones_calculo_incentivo: 315.28,
          incentivo: 141.88,
          total_a_pagar: 581.88
        },
        {
          vendedor: 'TRUJILLO - HUMBERTO ARAUJO',
          comision_primer_corte: 524.48,
          comision_segundo_corte: 0,
          total_comisiones_sin_incentivo: 524.48,
          comisiones_masivos: 524.48,
          comisiones_industriales: 0,
          comisiones_distribuidor: 0,
          porcentaje_incentivo: 0.65,
          comision_no_entra_incentivo: 0,
          comisiones_calculo_incentivo: 524.48,
          incentivo: 332.24,
          total_a_pagar: 856.72
        }
      ]
    }
  },
  mounted () {
    this.obtenerVendedoresFiltros()
    this.actualizar()
  },
  watch: {
    vendedoresFiltrados () {
      this.vendedoresSeleccionados = []
      this.agruparVendedoresSeleccionados()
    },
    fechaMes () {
      if (this.vendedoresFiltrados) {
        this.actualizar()
      }
    },
    fechaHasta () {
      if (!this.fechaHasta) return
      this.actualizar()
    },
    fechaDel () {
      if (!this.fechaHasta) return
      this.actualizar()
    }
  },
  methods: {
    agruparVendedoresSeleccionados () {
      this.vendedoresFiltrados.forEach(IdVende => {
        this.vendedores.forEach(vendefiltrado => {
          return vendefiltrado.id_per === IdVende ? this.vendedoresSeleccionados.push(vendefiltrado) : null
        })
      })
    },
    obtenerVendedoresFiltros () {
      apiPost({ s: 'vendedores' }, '')
        .then((res) => {
          this.vendedores = res.data.ven
        }).catch(() => {
          this.alertaMensaje = {
            contenido: 'Ocurrió un error obteniendo los vendedores',
            tipo: 'error'
          }
        })
    },
    restablecerFiltros () {
      this.restablecer = true
      this.vendedoresFiltrados = []
      this.vendedoresSeleccionados = []
      this.fechaMes = (new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).substr(-2)).toString()
      this.fechaDel = ''
      this.fechaHasta = ''
      this.actualizar()
    },
    actualizar () {
      console.log('actualizar')
    },
    convertirValorAFixed (numero) {
      return convertirNumeroAFixed(numero)
    },
    mesDelAño () {
      const meses = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ]
      return meses[parseInt(this.fechaMes.split('-')[1], 10) - 1]
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 80dvw;
  margin: 0 auto;
  padding: 20px;
}

table {
  border-collapse: collapse;
  width: 100%;
}

thead {
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px #dddddd solid;
  background-color: #fafafa;
}

th {
  font-weight: 600;
  text-align: left;
  padding: 10px 12px;
  white-space: nowrap;
  font-size: .7rem;
  text-transform: uppercase;
}

th:last-child {
  border-right: none;
}

td {
  padding: 14px 15px;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
  font-size: .75rem;
}

tr:hover td {
  background-color: #f9f9f9;
}

// tr:nth-child(even) {
//   background-color: #f8f9fa;
// }

tr:nth-child(even):hover td {
  background-color: #f1f3f4;
}

.table-container {
  border: 1px solid #e7e6e6;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 30px;
}

.table-wrapper {
  overflow: auto;
  max-height: 80dvh;
}

.ancho-1 {
  width: 300px;
}

.ancho-2 {
  width: 200px;
}

.ancho-3 {
  width: 100px;
}

.table.actividades {
  // Define los breakpoints para el responsive de ul.table
  @include ul-table-responsive-at ("576px");
}

.tabla-container {
  overflow: auto;
}

.contenedor-tabla {
  max-width: 80dvw;
}

@media (max-width: 1020px) {
  .container {
    width: 100dvw;
    padding: 0px;
  }

  .table-wrapper {
    width: 100dvw;
  }
}

@media (max-width: 576px) {
  .table-wrapper {
    max-height: none;
    overflow-x: hidden;
  }

  table {
    width: 100%;
  }

  thead {
    display: none;
  }

  tr {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid black;
    width: 90%
  }

  td {
    display: flex;
    flex-wrap: nowrap;
    padding-top: .5rem !important;
    padding-bottom: 0rem !important;
    height: auto !important;
    border: none;
    width: 90% !important;
    min-width: 0;
  }

  td::before {
    content: attr(data-columna) "                          " attr(second-data-columna);
    white-space: pre-wrap;
    font-weight: 500;
    margin-right: .25rem;
    min-width: 105px;
    width: 105px !important;
    flex-shrink: 0;
  }

  td>div {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  td>div>p,
  td>div>span {
    word-break: break-word;
    overflow-wrap: break-word;
    min-width: 0;
  }
}
</style>
